import { useCallback, useEffect } from 'react';

import { useClipboard } from '@hsp/react-hooks';

import { SecretKeyApprovalProps } from '@c/notifications/components/secret-key-request/types/secret-key-approval.props';

export const useSecretKeyApprovalConfiguration = ({ secretKey }: Pick<SecretKeyApprovalProps, 'secretKey'>) => {
  const { copy, hasCopied, setValue } = useClipboard(secretKey, 3000);

  const handleCopy = useCallback(() => {
    copy();
  }, [copy]);

  useEffect(() => {
    setValue(secretKey);
  }, [secretKey, setValue]);

  return {
    handleCopy,
    hasCopied,
  };
};
